export const pause = async (timeout: number) => {
  await new Promise((res) => setTimeout(res, timeout));
};